<template lang="pug">
  .height-100

    .box
      .title Documentos importantes

      div(v-if="lista.length === 0 && !isLoading")
        .message.is-warning
          .message-body No hay documentos importantes ingresados
      loading(v-else-if="isLoading")
      .documentos-importantes
        div.p-10.pt-20
          ol
            li.cursor-pointer.text-left.transition-quick(
              v-for="(o, index) in lista"
              :class="{ selected: o.id === idSeleccionado }"
              @click="seleccionar(o)"
            )
              span {{ o.descripcion }}
        div.flex-1.p-10.height-calculado
          .article.message.is-info.margin-top-10.w-fit.margin-auto(v-if="!rutaSeleccionada")
            section.message-body
              span No ha seleccionado ningún documento
          iframe.full-width.height-100(
            :src="rutaSeleccionada"
          )
            | Oops! an error has occurred.
</template>

<script>
import { apiGet, notify } from '../util/general'

export default {
  name: 'documentos-importantes',
  data () {
    return {
      lista              : [],
      isLoading          : false,
      idSeleccionado     : null,
      rutaSeleccionada   : null
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true

      var obj = {
        activo: 1
      }

      apiGet(vm, '/documentos-importantes', obj, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    seleccionar (o) {
      var vm = this
      vm.idSeleccionado = o.id
      vm.rutaSeleccionada = o.ruta
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

  .selected
    font-weight bold
    color #3a4dc7

  .transition-quick
    transition: all .15s ease;

  .height-calculado
    height calc(100vh - 179px)

  .title
    font-size 16px
    font-weight bold
    text-transform uppercase

  .documentos-importantes
    display: flex;

  @media (max-width: 700px)
    .documentos-importantes
      flex-direction column
      iframe
        height 100vh

</style>




// WEBPACK FOOTER //
// View_Documentos_Importantes.vue?b6a07318